// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"c6e64919","780":"a38e2028"}[chunkId] + ".chunk.css";
};